import { API_BASE_URL} from "../baseURL";

const AddMultiplicatorModal = ({ setMultiplicators, setShowAddMultiplicatorModal }) => {
    function create() {
      /*  console.log("firstname: " + document.getElementById("firstname").value);
        console.log("surname: " + document.getElementById("surname").value);
        console.log("firm: " + document.getElementById("firm").value);
        console.log("comment: " + document.getElementById("comment").value);*/

        fetch(`${API_BASE_URL}/multiplicators/create-multiplicator`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify(
                {
                    multiplicatorId: 0,
                    firstName:  document.getElementById("firstname").value,
                    surname:    document.getElementById("surname").value,
                    firm:       document.getElementById("firm").value,
                    comment:    document.getElementById("comment").value
                }
            )
        }).then(response => response.json())
            .then(data => setMultiplicators(data))
    }

    return (
        <>
            <div className="custom-modal">
                <div className="custom-modal-dialog">
                    <div>
                        <button onClick={() => setShowAddMultiplicatorModal(false)} style={{float: "right"}}> &times; </button>
                        <h4> Neuer Multiplikator </h4>
                    </div>

                    <br/>

                    <table>
                        <tbody>
                        <tr>
                            <td style={{width: "20%"}}><b> Nachname </b></td>
                            <td><input type="text" id="surname"></input></td>
                        </tr>

                        <tr>
                            <td style={{width: "20%"}}><b> Vorname </b></td>
                            <td><input type="text" id="firstname"></input></td>
                        </tr>

                        <tr>
                            <td style={{width: "20%"}}><b> Unternehmen </b></td>
                            <td><input type="text" id="firm"></input></td>
                        </tr>

                        <tr>
                            <td style={{width: "20%"}}><b> Kommentar </b></td>
                            <td><input type="text" id="comment"></input></td>
                        </tr>
                        </tbody>
                    </table>

                    <div style={{marginTop: "20px"}}>
                        <button onClick={() => { setShowAddMultiplicatorModal(false); }} className="custom-btn-close" > Schließen </button>
                        <button
                            onClick={() => {
                                setShowAddMultiplicatorModal(false)
                                create()
                                }
                            }
                            className="custom-btn-save"> Speichern </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddMultiplicatorModal;
